
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import SportHeader from '@/components/sports/common/SportHeader.vue';
import EventCardOld from '@/components/sports/common/event/EventCardOld.vue';
import CompetitionLogo from '@/components/sports/common/competition/logos/CompetitionLogo.vue';

import type { SportEventBucketsEdgeV2, SportType } from '@/@types/graphql-types';
import { SportPageType } from '@/interfaces/sport-graphql';

@Component({
	name: 'CompetitionEventsItemOld',
	components: {
		SportHeader,
		EventCardOld,
		CompetitionLogo,
	},
})
export default class CompetitionEventsItemOld extends Vue {
	@Prop({ required: true }) sportType: SportType;
	@Prop({ default: false }) hideHeader: boolean;
	@Prop({ required: true }) competition: SportEventBucketsEdgeV2;
	@Prop() sportPageType: SportPageType;

	get parentCompetition() {
		return this.competition.key.parent?.competition ?? this.competition.key.competition;
	}

	get fullPath() {
		return this.parentCompetition?.content.fullPath;
	}

	get name() {
		return this.parentCompetition?.content.name;
	}
}
